module.exports = __webpack_public_path__ + "img/OGBull.05504.37aacc36.webp";